import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Shipment-Remove--Streamline-Flex"
    >
        <desc>
            {'Shipment Remove Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="shipment-remove--shipping-parcel-shipment-remove-subtract">
            <path
                id="Subtract"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.25403 4.03081S2.63733 1.00978 3.76168 0.910383C4.83454 0.815537 5.72084 0.75 6.99991 0.75c1.26741 0 2.14919 0.064348 3.20899 0.157799 1.1164 0.098451 2.5354 3.120791 2.5354 3.120791"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m6.99988 3.24988 0 -2.499713"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.10671 12.0599c0.07459 0.4842 0.4674 0.8575 0.94885 0.8952 1.58141 0.124 3.23797 0.2948 4.94442 0.2948 1.70645 0 3.36302 -0.1708 4.94442 -0.2948 0.4814 -0.0377 0.8743 -0.411 0.9488 -0.8952 0.1631 -1.0584 0.3568 -2.67552 0.3568 -3.81002s-0.1937 -2.75166 -0.3568 -3.81004c-0.0745 -0.4842 -0.4674 -0.85746 -0.9488 -0.89521 -1.5814 -0.12401 -3.23797 -0.29475 -4.94442 -0.29475 -1.70645 0 -3.36301 0.17074 -4.94442 0.29475 -0.48145 0.03775 -0.87426 0.41101 -0.94885 0.89521C0.943679 5.49822 0.75 7.11538 0.75 8.24988s0.193679 2.75162 0.35671 3.81002Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 8.24988h5"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
